// eslint-disable-next-line jira/restricted/graphql-tag
import gql from 'graphql-tag';
import { CASCADING_SELECT_FRAGMENT } from '../field-types/cascading-select/fragment/gql.tsx';
import { DATE_FRAGMENT } from '../field-types/date/fragment/gql.tsx';
import { DATE_TIME_FRAGMENT } from '../field-types/datetime/fragment/gql.tsx';
import { DEV_SUMMARY_FRAGMENT } from '../field-types/dev-summary/fragment/gql.tsx';
import { GOALS_FRAGMENT } from '../field-types/goals/fragment/gql.tsx';
import { GROUP_FRAGMENT } from '../field-types/group/fragment/gql.tsx';
import { LABELS_FRAGMENT } from '../field-types/labels/fragment/gql.tsx';
import { MULTIPLE_SELECT_FRAGMENT } from '../field-types/multi-select/fragment/gql.tsx';
import { NUMBER_FRAGMENT } from '../field-types/number/fragment/gql.tsx';
import { PARENT_FRAGMENT } from '../field-types/parent/fragment/gql.tsx';
import { PRIORITY_FRAGMENT } from '../field-types/priority/fragment/gql.tsx';
import { PROJECT_FRAGMENT } from '../field-types/project/fragment/gql.tsx';
import { RADIO_SELECT_FRAGMENT } from '../field-types/radio-select/fragment/gql.tsx';
import { RESOLUTION_FRAGMENT } from '../field-types/resolution/fragment/gql.tsx';
import { SINGLE_SELECT_FRAGMENT } from '../field-types/single-select/fragment/gql.tsx';
import { STATUS_CATEGORY_FRAGMENT } from '../field-types/status-category/fragment/gql.tsx';
import { TEAM_FRAGMENT } from '../field-types/team/fragment/gql.tsx';
import { SINGLE_LINE_TEXT_FRAGMENT } from '../field-types/text/fragment/gql.tsx';
import { URL_FRAGMENT } from '../field-types/url/fragment/gql.tsx';
import {
	USER_FRAGMENT,
	PEOPLE_FRAGMENT,
	MULTIPLE_USER_FRAGMENT,
	ATLASSIAN_ACCOUNT_FRAGMENT,
} from '../field-types/user/fragment/gql.tsx';
import { VERSION_FRAGMENT } from '../field-types/version/fragment/gql.tsx';

export const JIRA_BUSINESS_FIELDS_FRAGMENT = gql`
	${PARENT_FRAGMENT}
	${VERSION_FRAGMENT}
	${TEAM_FRAGMENT}
	${GOALS_FRAGMENT}
	${RESOLUTION_FRAGMENT}
	${GROUP_FRAGMENT}
	${LABELS_FRAGMENT}
	${DATE_FRAGMENT}
	${DATE_TIME_FRAGMENT}
	${ATLASSIAN_ACCOUNT_FRAGMENT}
	${USER_FRAGMENT}
	${PEOPLE_FRAGMENT}
	${MULTIPLE_USER_FRAGMENT}
	${PRIORITY_FRAGMENT}
	${MULTIPLE_SELECT_FRAGMENT}
	${NUMBER_FRAGMENT}
	${RADIO_SELECT_FRAGMENT}
	${SINGLE_SELECT_FRAGMENT}
	${URL_FRAGMENT}
	${SINGLE_LINE_TEXT_FRAGMENT}
	${STATUS_CATEGORY_FRAGMENT}
	${CASCADING_SELECT_FRAGMENT}
	${PROJECT_FRAGMENT}
`;

export const JIRA_BUSINESS_TOP_LEVEL_FIELD_FRAGMENT = gql`
	${DEV_SUMMARY_FRAGMENT}
`;
